<template>
  <div class="exchange">
    <exchange/>
    <detail-btn @clickHandle="setShowDetail" @refresh="refresh" label="View my History" style="margin:0.4rem 0 1.2rem 0;"/>
    <detail v-if="showDetail" ref="exchangeDetail"/>
  </div>
</template>

<script>
import exchange from "./exchange.vue"
import detail from "./detail.vue"
import detailBtn from "@/components/DetailBtn/index.vue"
export default {
  components: {
    exchange,
    detail,
    detailBtn
  },
  data() {
    return {
      showDetail:false,
    };
  },
  computed: {

  },
  methods: {
    setShowDetail(){
      this.showDetail = true;
      this.$nextTick(() => {
        this.refresh();
      })
    },
    refresh(){
      this.$refs.exchangeDetail && this.$refs.exchangeDetail.refresh();
    }

  },
  created() {

  },
  mounted() {}
};
</script>
<style scoped lang="scss">

</style>
